import emptySliceApi from '../../../../../../shared/store/emptyApiSlice';

export const apiSlice = emptySliceApi.injectEndpoints({
  endpoints: (builder) => ({
    updatePmiId: builder.mutation<
      void,
      { accountId: string; userId: string; personId: number }
    >({
      query: ({ accountId, userId, personId }) => ({
        url: `v4/accounts/${accountId}/users/${userId}/validated-person-id`,
        body: { personId },
        method: 'PUT',
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const { useUpdatePmiIdMutation } = apiSlice;
